import { Component, Fragment } from "preact";

export default class MessageForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            messageInput: ''
        }
    }

    onKeyDown(e) {
        if (e.key === 'Enter' && !e.shiftKey && this.state.messageInput) {
            e.preventDefault();
            e.stopPropagation();
            this.handleMessageSend()
        }
    }

    handleMessageSend() {
        this.setState({
            messageInput: ''
        });

        this.props.onSubmit(this.state.messageInput);
    }

    render() {
        return (
            <Fragment>
                <input
                    onInput={(e) => this.setState({messageInput: e.target.value})}
                    onKeyDown={this.onKeyDown.bind(this)}
                    type={'text'}
                    className={'message'}
                    value={this.state.messageInput}
                    placeholder={'...'}
                />
                <button
                    onClick={this.handleMessageSend.bind(this)}
                    className={'send'}
                    disabled={!this.state.messageInput}
                />
            </Fragment>
        )
    }
}